export default __webpack_public_path__ + "img/eKgJMMbb.5e52fec4.svg";